import loading from "../../assets/images/loading.gif";

const Loading = (props) => {
  const { width } = props;

  return (
    <div style={{
      position: "absolute",
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(255, 255, 255, 0.6)',
      zIndex: 999,
      display: "flex",
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <img src={loading} alt="로딩중입니다." width={width || '5%'}></img>
    </div>
  )

}

export default Loading;
